<!-- Footer -->
<footer class="page-footer">
  <!-- Copyright -->
  <div class="footer-copyright text-center py-3">
    © {{ today | date: 'yyyy' }} Copyright
    <a href="https://unthealth.edu/"> UNT Health Fort Worth</a>
    <p class="mt-2">
      <a class="policy-link" href="https://www.unthealth.edu/privacy-notice.html" target="_blank"> Privacy Policy</a>
    </p>
  </div>
  <!-- Copyright -->
</footer>
<!-- Footer -->